"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectInputForceStyles = void 0;
const getSelectInputForceStyles = (hasIcon = false) => ({
    pl: hasIcon ? ['44px', '52px'] : undefined,
});
exports.getSelectInputForceStyles = getSelectInputForceStyles;
//# sourceMappingURL=SelectInput.styles.js.map